// extracted by mini-css-extract-plugin
export default {"container":"FFgCW","containerInner":"XBSBd","containerInnerLeft":"Gbj1z","containerInnerLeftTitle":"B8On7","containerInnerLeftContent":"_2LPSg","containerInnerRight":"sUEex"};